import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Avatar from '../Helpers/Avatar';
import * as ActionCreators from '../../actions/actions';
import './User.css';
import { Form, FormTextarea, FormButton, FormCardGroup, FormRadio, AlertForm, RadioValues } from '../Helpers/Form';
import Comment from './Comment';
import PetCard from '../Pets/PetCard';
import Storage from '../Helpers/Storage/Storage';
import Scores from '../Helpers/Storage/Scores.json';
import HouseSituation from '../Helpers/Storage/HouseSituation.json';
import LandScapeSituation from '../Helpers/Storage/LandScapeSituation.json';

const scoreValues = new Map(Scores);

class User extends Component {
  static calculateAge(birthday) {
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  constructor(props) {
    super(props);
    const { userId } = props.match.params;
    props.showProfile(userId);
  }

  render() {
    const {
      ratingChange, createRating, userVm, petsVm,
      authVm: { uid },
      ratingVm,
      showProfile,
      match: { params: { userId } }
    } = this.props;
    const {
      displayName, place, aboutMe, plz, requestUid, comment,
      houseSituation,
      landScapeSituation,
      birthday, score,
      pricePerNight,
      pricePerDayAtMe,
      pricePerDayAtYou,
      priceClean
    } = userVm;
    const rating = parseInt(userVm.rating, 10);
    const ratingText = scoreValues.get(rating);
    if (userId !== userVm.uid) {
      showProfile(userId);
    }
    return (
      <div className="user">
        <article className="userInformations">
          <div>
            <Avatar {...userVm} alt={displayName} />
            {userId === uid ? <Link to="/usersettings">Bearbeiten</Link> : <Link to={`/request/${userId}`}>Anfrage</Link>}
          </div>
          <div>
            <h2>{displayName}</h2>
            <p>{plz}</p>
            <p>{place}</p>
            <p>{birthday && !Number.isNaN(birthday) && `${User.calculateAge(new Date(birthday))} Jahre`}</p>
            <p>{aboutMe}</p>
            <p>Preis pro Tag bei mir: {pricePerDayAtMe || 0}<br />
            Zusätzlich pro Nacht: {pricePerNight || 0}<br />
            Preis pro Tag bei dir: {pricePerDayAtYou || 0}<br />
            Preis für Komplettreinigung: {priceClean || 0}
            </p>
            {(houseSituation) && (
              <div>
                <FormCardGroup type="card" text="Wohnsituation">
                  <RadioValues readOnly selectedValue={houseSituation} possibleValues={HouseSituation} name="houseSituation" />
                  <RadioValues readOnly selectedValue={landScapeSituation} possibleValues={LandScapeSituation} name="landScapeSituation" />
                </FormCardGroup>
              </div>)}
            {score && (
              <div className="score">
                <FormCardGroup text="Bewertung" type="card">
                  {new Array(Math.floor(score))
                    .fill()
                    .map((_, index) => {
                      const key = index;
                      return (
                        <FormRadio
                          name="rating"
                          key={`score${key}`}
                          image={Storage.get('pawprint')}
                        />);
                    })}
                </FormCardGroup>
              </div>)}
          </div>
        </article>
        {petsVm.size !== 0 && (
          <article className="userpets">
            <Form>
              <FormCardGroup type="card">
                {Array.from(petsVm).map(([key, pet]) => (
                  <PetCard
                    to={`/pet/show/${key}`}
                    key={key}
                    {...pet}
                  />))}
              </FormCardGroup>
            </Form>
          </article>)}
        {ratingVm.size !== 0 && (
          <article className="ratings">
            { Array.from(ratingVm).map(([fromUid, value]) => <Comment key={fromUid} {...value} />)}
          </article>)}
        {requestUid && (
          <article className="createRating score">
            <AlertForm
              onSubmit={() => createRating(requestUid, userId, ({ comment, rating }))}
              onChange={({ name, value }) => ratingChange(name, value)}
            >
              <FormCardGroup text={`Bewertung schreiben${ratingText === undefined ? '' : ` ${ratingText}`}`} type="card">
                {Array.from(scoreValues)
                  .map(([key]) => (
                    <FormRadio
                      className={(rating >= key) ? 'voted' : 'notVoted'}
                      key={key}
                      name="rating"
                      value={key}
                      selectedValue={rating}
                      image={Storage.get('pawprint')}
                    />))}
              </FormCardGroup>

              <FormTextarea value={comment} name="comment" />
              <FormButton text="senden" />
            </AlertForm>
          </article>)
        }
      </div>
    );
  }
}

export default connect(
  state => ({
    ...state.userReducer, ...state.petsReducer, ...state.authReducer
  }),
  dispatch => bindActionCreators(ActionCreators, dispatch)
)(User);



// WEBPACK FOOTER //
// ./src/pages/User/index.js